import {useState} from 'react';
import {Typography} from 'antd';
import {KycDashboardTab} from './KycDashboardTab';
import {ManualKycQueueTab} from './ManualKycQueueTab';
import {AutomaticKycQueueTab} from './AutomaticKycQueueTab';
import {KycViewer} from './KycViewer';
import styles from './kycDashboard.module.scss';

const {Title, Text} = Typography;

const TABS = [
  {key: 'DASHBOARD', label: 'KYC Dashboard'},
  {key: 'MANUAL_QUEUE', label: 'Manual Review'},
  {key: 'AUTOMATIC_QUEUE', label: 'Automatic Review'},
  {key: 'COMPLYCUBE', label: 'KYC Data Lake'},
];

export const KycDashboard = () => {
  const [activeTab, setActiveTab] = useState('DASHBOARD');

  return (
    <div className={styles.shell}>
      <div className={styles.pageHeader}>
        <Title level={2}>KYC</Title>
        <Text type="secondary">
          Monitor verification status and metrics, work the manual and automatic
          review queues, and browse ComplyCube records
        </Text>
      </div>

      <div className={styles.tabBar} role="tablist">
        {TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={activeTab === tab.key}
            className={
              activeTab === tab.key ? styles.tabActive : styles.tabButton
            }
            onClick={() => setActiveTab(tab.key)}>
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.tabPanel} role="tabpanel">
        {activeTab === 'DASHBOARD' && <KycDashboardTab />}
        {activeTab === 'MANUAL_QUEUE' && <ManualKycQueueTab />}
        {activeTab === 'AUTOMATIC_QUEUE' && <AutomaticKycQueueTab />}
        {activeTab === 'COMPLYCUBE' && <KycViewer />}
      </div>
    </div>
  );
};
